import React,{useState} from 'react'
import {Modal, Spinner} from 'react-bootstrap'
import { getRequiredProtectedData } from '../../redux/apicalltemplate';
import moment from 'moment';
import {  userApis } from '../../redux/api';
import { useEffect } from 'react';
import { BellRing, CheckCircle2, CircleUserRound, Music2, Radio, Sparkles } from 'lucide-react';
import './Notification.css';

const Notification=({show,setShow})=>{
    const handleClose = () => setShow(false);
    const [notification,setNotifications]=useState(null)
    const [page]=useState(1);
    const [loading,setLoading]=useState(false)


    useEffect(() => {
  const _runEffect = async () => {
    const params = {
      page: page,
      order: -1,
      sortBy: 'created_at',
      limit: 100
    };
    setLoading(true);
    const responselist = await getRequiredProtectedData('GET', userApis.NOTIFICATION, {}, params);
    if (responselist && responselist.data && responselist.data.data) {
      setNotifications(responselist.data.data);
    } else {
      setNotifications(null);
    }
    setLoading(false);
  };
  _runEffect();
},[page])

return(
    <Modal dialogClassName="tm-notification-dialog" className="tm-notification-modal" show={show} onHide={handleClose} size="lg" centered>
        <Modal.Header closeButton>
            <div className="tm-notification-heading">
              <span className="tm-notification-heading-icon"><BellRing size={18} aria-hidden="true" /></span>
              <div>
                <Modal.Title>Notifications</Modal.Title>
                <p>{notification?.length || 0} recent account updates</p>
              </div>
            </div>
        </Modal.Header>
        <Modal.Body>
        <div className="tm-notification-list" >
        {
            loading ?
            <div className='tm-notification-state'>
                <Spinner hidden={false}  animation="border" />
                <span>Loading activity…</span>
            </div>:
              notification && notification.length ?  notification.map((el,i)=>
                <article key={el._id || i} className='tm-notification-item'>
                  <span className={`tm-notification-item-icon tm-notification-item-icon--${String(el.category || '').toLowerCase().replace(/\s+/g, '-') || 'general'}`}>
                    {String(el.category || '').toLowerCase().includes('music') ? <Music2 size={18} /> : String(el.category || '').toLowerCase().includes('profile') ? <CircleUserRound size={18} /> : String(el.subject || '').toLowerCase().includes('verified') ? <CheckCircle2 size={18} /> : String(el.category || '').toLowerCase().includes('crowd') ? <Radio size={18} /> : <Sparkles size={18} />}
                  </span>
                  <div className="tm-notification-copy">
                    <div className="tm-notification-meta">
                      <span className="tm-notification-category">{el.category || 'Platform'}</span>
                      <time title={moment(el.created_at).format('YYYY-MM-DD HH:mm')}>{moment(el.created_at).fromNow()}</time>
                    </div>
                    <h3>{el.subject || 'Account update'}</h3>
                    <p>{el.content || 'You have a new account update.'}</p>
                  </div>
                </article>
                ):
                <div className='tm-notification-state tm-notification-state--empty'>
                  <BellRing size={28} aria-hidden="true" />
                  <strong>No notifications yet</strong>
                  <span>Important account and campaign updates will appear here.</span>
                </div>
        }

        </div>


        </Modal.Body>
        <Modal.Footer>
          <span>Showing the latest {notification?.length || 0} updates</span>
          <button type="button" onClick={handleClose}>Done</button>
        </Modal.Footer>
    </Modal>
)


}

export default Notification
